<p-colorPicker
  [format]="format"
  [(ngModel)]="value"
  [appendTo]="appendTo"
  [ngModelOptions]="{ standalone: true }"
  (ngModelChange)="onChangeColor($event)"
/>
